import cx from 'classnames';
import * as React from 'react';

import Icon from 'components/Icon';
import MediaObject from 'components/MediaObject';
import Text, { OptionalProps as TextProps } from 'components/Text';

import { IconColor, IconName, IconSize } from 'components/Icon';
import { MediaObjectGutter } from 'components/MediaObject';

export type Props = {
  appendIcon?: boolean;
  center?: boolean;
  children?: React.ReactNode;
  className?: string;
  gutter?: MediaObjectGutter;
  icon: IconName;
  iconClassName?: string;
  iconColor?: IconColor;
  iconSize?: IconSize;
  inline?: boolean;
} & TextProps;

export default function TextWithIcon(props: Props) {
  const {
    appendIcon,
    center = true,
    children,
    className,
    gutter = 'xsmall',
    icon,
    iconClassName,
    iconColor = 'currentColor',
    iconSize = 'medium',
    inline,
    lineHeight = 'flush',
    ...others
  } = props;

  const iconComponent = (
    <Icon name={icon} color={iconColor} size={iconSize} className={iconClassName} />
  );

  const textComponent = (
    <Text {...others} align="left" lineHeight={lineHeight}>
      {children}
    </Text>
  );

  return (
    <MediaObject
      center={center}
      figure={appendIcon ? 'right' : 'left'}
      gutter={gutter}
      inline={inline}
      className={cx('TextWithIcon', className)}>
      {appendIcon ? textComponent : iconComponent}
      {appendIcon ? iconComponent : textComponent}
    </MediaObject>
  );
}
